import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { APP_COLOR } from "../../theme";

interface ItemProps {
  isSharpNote?: boolean;
  itemClicked?: boolean;
}

interface RootProps {
  height: string;
}

export const Item = styled(Button, {
  shouldForwardProp: (prop) =>
    !["isSharpNote", "itemClicked"].includes(prop as string),
})<ItemProps>(({ theme, isSharpNote, itemClicked }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: "white",
  width: "100%",
  minWidth: "30px",
  height: "30px",
  minHeight: "30px",
  border: "1px solid #303030",
  borderRadius: 0,
  backgroundColor: itemClicked ? APP_COLOR : "#202121",
  ":hover": {
    backgroundColor: itemClicked ? "#31E2F9" : "#303030",
  },
  "&:disabled": {
    backgroundColor: isSharpNote ? "black" : "white",
    color: isSharpNote ? "white" : "black",
  },
}));

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "height",
})<RootProps>(({ height }) => ({
  height: height,
  margin: "5px",
  zIndex: 900,
  position: "fixed",
  bottom: "0px",
  overflowX: "auto",
  overflowY: "auto",
}));

export const styles = {
  dragger: {
    width: "100%",
    height: "5px",
    cursor: "ns-resize",
    padding: "4px 0 0",
    borderTop: "1px solid white",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    backgroundColor: "#f4f7f9",
  } as const,
};
